import { getItem, setItem } from '@/utils/storage.js'
import { MAIN_COLOR, DEFAULT_COLOR } from '@/constant/index.js'
import variables from '@/styles/variables.module.scss'
export default {
  namespaced: true,
  state: () => ({
    mainColor: getItem(MAIN_COLOR) || DEFAULT_COLOR,
    variables
  }),
  mutations: {
    setMainColor(state, newColor) {
      state.mainColor = newColor
      setItem(MAIN_COLOR, newColor)
      state.variables.menuBg = newColor // 触发cssVar的更新
    }
  }
}
